import { render, staticRenderFns } from "./ConfigHeader.vue?vue&type=template&id=f9fb8fe8&scoped=true"
import script from "./ConfigHeader.vue?vue&type=script&lang=js"
export * from "./ConfigHeader.vue?vue&type=script&lang=js"
import style0 from "./ConfigHeader.vue?vue&type=style&index=0&id=f9fb8fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fb8fe8",
  null
  
)

export default component.exports